import { CsvRow } from "./collectRows"

const HEADERS: (keyof CsvRow)[] = [
  "content_id",
  "de_obj_id",
  "en_obj_id",
  "de_widget_id",
  "en_widget_id",
  "object_class",
  "page_path",
  "page_title_de",
  "breadcrumb",
  "attribute",
  "attribute_type",
  "index",
  "de_value",
  "en_value"
]

function quoteCell(value: string): string {
  return `"${value.replace(/"/g, '""')}"`
}

export function generateCsv(rows: CsvRow[]): string {
  const header = HEADERS.map(quoteCell).join(",")
  const dataLines = rows.map(row =>
    HEADERS.map(h => quoteCell(row[h])).join(",")
  )
  return [header, ...dataLines].join("\r\n")
}

const UTF8_BOM = "﻿"

export function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob([UTF8_BOM, csv], { type: "text/csv;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
